
import {initWebComponent} from "@/helpers/web-component-helper";
import {getAnimationDuration, zoomOut} from "@/helpers/ol/ol-event-helper";
import {OlZoomInComponent} from "@/components/ol/buttons/ol-zoom-in-component";
import {OlDrawGeometryComponent} from "@/components/ol/buttons/ol-draw-geometry-component";
import {OlDrawGeometryTypeComponent} from "@/components/ol/buttons/ol-draw-geometry-type-component";

const template = document.createElement('template');
template.innerHTML = `<footer-button data-title="Zoom uit" data-icon="fa fa-minus">`;

export class OlZoomOutComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            zoomOut()
            this.firstChild.firstChild.classList.add('active')
            setTimeout(() => {
                this.firstChild.firstChild.classList.remove('active')
            }, getAnimationDuration())
        });
    }
}


window.customElements.define("ol-draw-geometry", OlDrawGeometryComponent);
window.customElements.define("ol-draw-geometry-type", OlDrawGeometryTypeComponent);
